import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MappingFilterEntityInterface } from '../mapping-filter-entity.interface';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'hhsg-mapping-detail',
  templateUrl: './mapping-detail.component.html',
  styleUrls: ['./mapping-detail.component.scss']
})
export class MappingDetailComponent {

  @Input() mappingForm: NgForm;
  @Input() filterEntityDisplayName: string;
  @Input() filterEntities: MappingFilterEntityInterface[];
  @Input() filterEntityId: number = -1;
  @Input() typeDropdownTemplate: TemplateRef<HTMLElement>;
  @Output() beforeFilterEntityDropDownChangedEvent = new EventEmitter<any>();

  @ViewChild('addMappingTemplate') addMappingTemplate: TemplateRef<any>;

  @Input() hasfooter: boolean = true;
  @Input() buttonIsDisabled: boolean;
  @Input() adminActionLoading: any;
  @Input() errorMessage: string;
  @Input() adminActionLabelText:string;
  @Input() mappingDialogTemplate: TemplateRef<HTMLElement>;
  

  @Output() onSaveEvent: EventEmitter<any> = new EventEmitter();
  @Output() onCancelEvent: EventEmitter<any> = new EventEmitter();
  @Output() onDialogSaveEvent: EventEmitter<any> = new EventEmitter();
  constructor(public dialog: MatDialog) { }

  beforeFilterEntityDropDownChanged(event: any) {
      this.beforeFilterEntityDropDownChangedEvent.emit(event);
  }
  onSave(){
    this.onSaveEvent.emit();
  }
  onCancel(){
    this.onCancelEvent.emit();
  }
  openDialog() {
    const dialogRef = this.dialog.open(this.addMappingTemplate);
  }
  onDialogSave(){
    this.onDialogSaveEvent.emit();
  }
}
